/**
 * Badge Component - Status indicators with variants
 */

import React from 'react';
import { colors, spacing, borderRadius } from '../../styles/design-tokens';

const Badge = React.forwardRef(({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  icon = null,
  dot = false,
  ...props
}, ref) => {
  const variants = {
    default: 'bg-neutral-100 text-neutral-700 border-neutral-200',
    primary: 'bg-brand-soft text-brand border-brand-soft',
    success: 'bg-success-soft text-success border-success-soft',
    warning: 'bg-warning-soft text-warning border-warning-soft',
    error: 'bg-error-soft text-error border-error-soft',
    info: 'bg-info-soft text-info border-info-soft',
    outline: 'bg-transparent text-ink border-neutral-200',
    gold: 'bg-gold-soft text-gold border-gold-soft',
    teal: 'bg-teal-soft text-teal border-teal-soft',
  };

  const sizes = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-[11px]',
    lg: 'px-3.5 py-1.5 text-xs',
  };

  const baseStyles = `
    inline-flex items-center gap-1.5
    font-semibold
    border
    rounded-full
    ${variants[variant] || variants.default}
    ${sizes[size] || sizes.md}
    ${className}
  `;

  return (
    <span ref={ref} className={baseStyles} {...props}>
      {dot && (
        <span className={`
          w-1.5 h-1.5 rounded-full
          ${variant === 'success' ? 'bg-success' : ''}
          ${variant === 'warning' ? 'bg-warning' : ''}
          ${variant === 'error' ? 'bg-error' : ''}
          ${variant === 'primary' ? 'bg-brand' : ''}
          ${variant === 'info' ? 'bg-info' : ''}
          ${variant === 'gold' ? 'bg-gold' : ''}
          ${variant === 'teal' ? 'bg-teal' : ''}
          ${variant === 'default' ? 'bg-neutral-400' : ''}
          ${variant === 'outline' ? 'bg-neutral-400' : ''}
        `} />
      )}
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </span>
  );
});

Badge.displayName = 'Badge';

export default Badge;